import { PreWraper } from '@components/shared/wraper/PreWraper'
import { ProgramLabel } from '@type/buzzkuri/programs'
import React from 'react'
import { SummaryProgramHeading } from '../Heading'

type Props = {
  preparations: ProgramLabel[]
  preparationStuffs: string
}

export const SummaryProgramPreparations = ({
  preparations,
  preparationStuffs,
}: Props): JSX.Element => (
  <div className="flex flex-col mt-[9.3vw] lg:mt-[3.1vw]">
    <SummaryProgramHeading heading="必要準備物" />
    <div
      className={`mt-[5.8vw] lg:mt-[2.2vw] ${
        !!preparationStuffs && 'whitespace-pre-wrap'
      }`}
    >
      {!!preparationStuffs ? (
        preparationStuffs
      ) : (
        <ul className="list-disc list-inside">
          {preparations.map(({ name }, i) => (
            <li
              key={i}
              className="text-[4.3vw] lg:text-[1.3vw] leading-[8.5vw] lg:leading-[2.5vw] text-[#333333]"
            >
              {name}
            </li>
          ))}
        </ul>
      )}
    </div>
    <div className="mt-[4.2vw] lg:mt-[1.6vw]">
      <div className="text-[3.7vw] lg:text-[1.1vw] leading-[7.5vw] lg:leading-[2.2vw] text-[#666666]">
        <PreWraper
          text={`イベントによっては上記以外で追加で準備が必要なものが発生する場合があります。\nイベント前に送られてくるメッセージを必ずご確認くださいますようお願いいたします。`}
        />
      </div>
    </div>
  </div>
)
